import { FileDragDrop } from 'features/autocheck/components/internal/FileDragDrop'
import { FileUploadDetails } from 'features/components'
import { useState } from 'react'
import styled from 'styled-components'

import { FileShareFileUploadButton } from './FileShareFileUploadButton'
import { Textarea } from '@outbound-ai/ursa'
import { COMMENT_CHAR_LIMIT } from '../constants'

interface IProps {
  setFileName: (value: string | null) => void
  closeModal: () => void
}

export const FileShareFilesUpload = ({ setFileName, closeModal }: IProps) => {
  const [file, setFile] = useState<File | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [comment, setComment] = useState('')
  const [exceededChar, setExceededChar] = useState(false)

  const handleDroppedFile = (droppedFile: File) => {
    setFileName(droppedFile.name)

    setFile(droppedFile)
  }

  const handleRemoveFile = () => {
    setFileName(null)
    setFile(null)
  }

  const handleValueChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const inputValue = e.target.value
    const charLeft = inputValue.length

    if (charLeft > COMMENT_CHAR_LIMIT) {
      setExceededChar(true)
      return
    }
    setComment(inputValue)
    setExceededChar(false)
  }

  return (
    <Div>
      <div className="file-container">
        {!file ? (
          <FileDragDrop onFile={handleDroppedFile} fileStyle={{ height: '13.25rem' }} />
        ) : (
          <FileUploadDetails file={file} onRemoveFile={handleRemoveFile} fileStyle={{ height: '13.25rem' }} />
        )}

        <div className="comment-container">
          <span className="title">Comments (Optional)</span>
          <Textarea
            value={comment}
            className="comments"
            placeholder="Add additional context or information to your file upload."
            size="small"
            resize="none"
            height="3.5rem"
            helperText={
              exceededChar ? <span className="exceeded-chars">Max. 125 characters</span> : 'Max. 125 characters'
            }
            onChange={(e) => handleValueChange(e)}
          />
        </div>

        <FileShareFileUploadButton
          file={file}
          comment={comment}
          loading={isLoading}
          onIsLoading={(status: boolean) => setIsLoading(status)}
          onRemoveFile={handleRemoveFile}
          closeModal={closeModal}
        />
      </div>
    </Div>
  )
}

const Div = styled.div`
  .file-container {
    padding: ${({ theme }) => theme.spacing.xxl};
    border-radius: ${({ theme }) => theme.borderRadius.rounded};
    border: solid 1px ${({ theme }) => theme.colors.grey.lighter};
    background-color: ${({ theme }) => theme.colors.neutral.lightest};
    .alert {
      margin-bottom: 1rem;
    }
  }
  .comment-container {
    margin: 1.5rem 0 1.5rem 0;
    .title {
      ${({ theme }) => theme.typography.xs.medium};
      margin-bottom: 0.25rem;
      display: block;
    }
    .comments {
    }
    .exceeded-chars {
      color: ${({ theme }) => theme.colors.error.dark};
    }
  }
`
